import React, { memo } from 'react'
import TextWithLinks from 'root/src/client/web/base/TextWithLinks'
import { fontFamily } from 'root/src/client/web/commonStyles'
import withStyles from '@material-ui/core/styles/withStyles'
import classNames from 'classnames'

const styles = {
	fontStyle: {
		fontFamily,
		fontWeight: 300,
		fontSize: 12,
		lineHeight: 1.2,
		marginBottom: 10,
	},
}

export const TertiaryBodyUnstyled = memo((({
	children, classes, className,
}) => (
	<div className={classNames(classes.fontStyle, className)}>
		<TextWithLinks text={children} />
	</div>
)))

export default withStyles(styles, { name: 'MuiTertiaryBody' })(TertiaryBodyUnstyled)
